import { defineStore } from "pinia";
import { reactive, ref } from "vue";
import { config } from "/@/cool";
import { deepMerge, getBrowser, storage } from "/@/cool/utils";
import { LAYOUT_MOBILE_BREAKPOINT } from "../common/layoutBreakpoint";

export const useAppStore = defineStore("app", function () {
	// 基本信息
	const info = reactive({
		...config.app
	});

	// 浏览器信息
	const browser = ref<any>(getBrowser());

	// 是否折叠（窄屏默认收起侧栏，避免遮挡主区）
	const isFold = ref(
		typeof document !== "undefined" &&
			document.documentElement.clientWidth < LAYOUT_MOBILE_BREAKPOINT
	);

	// 事件
	const events = reactive<{ [key: string]: any[] }>({
		hasToken: []
	});

	// 折叠
	function fold(v?: boolean) {
		if (v === undefined) {
			v = !isFold.value;
		}

		isFold.value = v;
	}

	// 设置基本信息
	function set(data: any) {
		deepMerge(info, data);
		storage.set("__app__", info);
	}

	// 设置浏览器信息
	function setBrowser() {
		browser.value = getBrowser();
	}

	// 添加事件
	function addEvent(name: string, func: any) {
		if (func) {
			events[name].push(func);
		}
	}

	return {
		info,
		browser,
		isFold,
		fold,
		events,
		set,
		setBrowser,
		addEvent
	};
});
